<p-dialog
    appDialogoPadrao="pi pi-briefcase"
    [visible]="visible()"
    (visibleChange)="visible.set($event)"
    [dismissableMask]="true"
    [style]="{ width: '60rem', maxWidth: '95vw' }"
    [showHeader]="false"
    (onHide)="onCancel()"
    [maximizable]="true"
    styleClass="compose-dialog"
>
    <!-- Container principal seguindo o padrão .compose-container dentro do diálogo -->
    <div class="compose-container animate-fade-in font-sans">
        <!--        &lt;!&ndash; Header Customizado (.custom-header) &ndash;&gt;-->
        <!--        <div class="custom-header">-->
        <!--            <div class="header-left">-->
        <!--                <button type="button" class="icon-btn back-btn">-->
        <!--                    <i class="pi pi-angle-left"></i>-->
        <!--                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-5 h-5">-->
        <!--                        <path stroke-linecap="round" stroke-linejoin="round" d="M15.75 19.5L8.25 12l7.5-7.5" />-->
        <!--                    </svg>-->
        <!--                </button>-->
        <!--                &lt;!&ndash; Avatar do Usuário (Simulando p-avatar) &ndash;&gt;-->
        <!--                <div class="avatar-wrapper">-->
        <!--                    <img src="https://images.unsplash.com/photo-1494790108377-be9c29b29330?ixlib=rb-1.2.1&auto=format&fit=facearea&facepad=2&w=256&h=256&q=80" alt="Avatar" class="avatar-img">-->
        <!--                </div>-->
        <!--                <div class="sender-info">-->
        <!--                    <div class="sender-name">Ioni Bowcher</div>-->
        <!--                    <div class="sender-to">Editando Tarefa #4290</div>-->
        <!--                </div>-->
        <!--            </div>-->
        <!--            <div class="header-right">-->
        <!--                <span class="date">Hoje, 11:30</span>-->
        <!--                <button type="button" class="icon-btn action-btn">-->
        <!--                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-5 h-5">-->
        <!--                        <path stroke-linecap="round" stroke-linejoin="round" d="M12 6.75a.75.75 0 110-1.5.75.75 0 010 1.5zM12 12.75a.75.75 0 110-1.5.75.75 0 010 1.5zM12 18.75a.75.75 0 110-1.5.75.75 0 010 1.5z" />-->
        <!--                    </svg>-->
        <!--                </button>-->
        <!--            </div>-->
        <!--        </div>-->

        <div class="content-card">
            <form [formGroup]="taskForm" class="form-layout">
                <!-- Título da Tarefa (Subject style) -->
                <div class="field-group">
                    <label class="field-label">Título da Tarefa</label>
                    <input type="text" formControlName="taskName" class="custom-input subject-input" placeholder="Digite o título da tarefa..." />
                </div>

                <!-- Editor Section (.editor-wrapper) -->
                <div class="field-group">
                    <label class="field-label">Descrição</label>
                    <div class="editor-wrapper">
                        <p-editor formControlName="description" [style]="{ height: '200px' }" styleClass="custom-editor">
                            <ng-template pTemplate="header">
                                <span class="ql-formats">
                                    <select class="ql-header">
                                        <option value="">Normal</option>
                                        <option value="1">Heading 1</option>
                                        <option value="2">Heading 2</option>
                                    </select>
                                    <select class="ql-font">
                                        <option selected>Sans Serif</option>
                                        <option value="serif">Serif</option>
                                        <option value="monospace">Monospace</option>
                                    </select>
                                </span>
                                <span class="ql-formats">
                                    <button class="ql-bold"></button>
                                    <button class="ql-italic"></button>
                                    <button class="ql-underline"></button>
                                </span>
                                <span class="ql-formats">
                                    <button class="ql-color"></button>
                                    <button class="ql-background"></button>
                                </span>
                                <span class="ql-formats">
                                    <button class="ql-list" value="ordered"></button>
                                    <button class="ql-list" value="bullet"></button>
                                    <button class="ql-align"></button>
                                </span>
                                <span class="ql-formats">
                                    <button class="ql-link"></button>
                                    <button class="ql-image"></button>
                                    <button class="ql-code-block"></button>
                                    <button class="ql-clean"></button>
                                </span>
                            </ng-template>
                        </p-editor>
                    </div>
                </div>

                <!-- Grid de Datas e Membros -->
                <div class="grid-layout">
                    <div class="field-group">
                        <label class="field-label">Data de Início</label>
                        <input type="date" formControlName="startDate" class="custom-input" />
                    </div>
                    <div class="field-group">
                        <label class="field-label">Data de Entrega</label>
                        <input type="date" formControlName="dueDate" class="custom-input" />
                    </div>
                </div>

                <!-- Team Members (Chips Style) -->
                <div class="field-group">
                    <label class="field-label">Membros da Equipe</label>
                    <div class="chips-container">
                        @for (member of members; track member) {
                            <div class="chip">
                                <img [src]="member.avatar" class="chip-avatar" />
                                <span class="chip-label">{{ member.name }}</span>
                                <button type="button" (click)="removeMember(member.id)" class="chip-remove">
                                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" class="w-3 h-3">
                                        <path d="M6.28 5.22a.75.75 0 00-1.06 1.06L8.94 10l-3.72 3.72a.75.75 0 101.06 1.06L10 11.06l3.72 3.72a.75.75 0 101.06-1.06L11.06 10l3.72-3.72a.75.75 0 00-1.06-1.06L10 8.94 6.28 5.22z" />
                                    </svg>
                                </button>
                            </div>
                        }
                        <input type="text" class="chip-input" placeholder="Adicionar..." />
                    </div>
                </div>

                <!-- Footer Principal (Alinhado com o estilo do botão Enviar do anexo) -->
                <div class="main-footer">
                    <button type="button" class="p-button-secondary-text" (click)="onCancel()">Cancelar</button>
                    <button type="button" class="p-button-primary" (click)="saveTask()">
                        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" class="w-4 h-4 mr-2">
                            <path stroke-linecap="round" stroke-linejoin="round" d="M6 12L3.269 3.126A59.768 59.768 0 0121.485 12 59.77 59.77 0 013.27 20.876L5.999 12zm0 0h7.5" />
                        </svg>
                        Salvar Tarefa
                    </button>
                </div>
            </form>
        </div>
    </div>
    <ng-template pTemplate="footer">
        <!-- Footer vazio para manter consistência visual se necessário -->
    </ng-template>
</p-dialog>
